var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
import { ControlError } from './ControlError';
import { MultiSelect } from 'primereact/multiselect';
import * as R from 'ramda';
var MultiSelectControl = /** @class */ (function (_super) {
    __extends(MultiSelectControl, _super);
    function MultiSelectControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.multiSelectRef = null;
        _this.multiSelectFilterRef = null;
        _this.optionRender = function (supportedValues) { return function (option) {
            var optionInSupportedValues = !!supportedValues ? supportedValues.find(function (value) { return value.value === option; }) : null;
            return option ? (React.createElement("span", { className: "multiselect-label-item" }, !!optionInSupportedValues ? optionInSupportedValues.label : option)) : (React.createElement("span", null));
        }; };
        _this.onChange = function (target) { return function (evt) {
            _this.handleChange(evt.value);
            var type = target.actionButton;
            if (type) {
                _this.props.onEvent({ type: type, target: target });
            }
        }; };
        // TODO: remove after update prime-react
        _this.clearFilter = function () {
            var hasFilter = R.path(['def', 'frontOptions', 'filter'], _this.state);
            if (hasFilter) {
                _this.multiSelectFilterRef.value = '';
                _this.multiSelectRef.setState({ filter: '' }, _this.forceUpdate);
            }
        };
        _this.onHide = function () {
            _this.clearFilter();
            var addClass = function (element, className) {
                if (element) {
                    if (element.classList) {
                        element.classList.add(className);
                    }
                    else {
                        element.className += ' ' + className;
                    }
                }
            };
            var removeClass = function (element, className) {
                if (element) {
                    if (element.classList) {
                        element.classList.remove(className);
                    }
                    else {
                        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    }
                }
            };
            addClass(_this.multiSelectRef.panel.element, 'p-input-overlay-hidden');
            removeClass(_this.multiSelectRef.panel.element, 'p-input-overlay-visible');
            _this.multiSelectRef.unbindDocumentClickListener();
            _this.multiSelectRef.clearClickState();
            setTimeout(function () {
                if (!!_this.multiSelectRef && !!_this.multiSelectRef.panel && !!_this.multiSelectRef.panel.element) {
                    _this.multiSelectRef.panel.element.style.display = 'none';
                    removeClass(_this.multiSelectRef.panel.element, 'p-input-overlay-hidden');
                }
            }, 150);
        };
        return _this;
    }
    MultiSelectControl.prototype.elementRender = function (def) {
        var _this = this;
        var frontOptions = def.frontOptions, supportedValues = def.supportedValues;
        var hint = frontOptions.hint, label = frontOptions.label, restOptions = __rest(frontOptions, ["hint", "label"]);
        var printLabel = label || def.label;
        return def.hidden ? null : (React.createElement("div", { className: mapElementClass(restOptions) },
            React.createElement("label", { htmlFor: def.id, title: printLabel }, printLabel),
            React.createElement(MultiSelect, __assign({}, omitSpecialProperties(restOptions), { ref: function (ref) {
                    if (ref) {
                        ref['container'].setAttribute('field-code', def.code);
                        _this.multiSelectRef = ref;
                        _this.multiSelectFilterRef = ref.panel.element.childNodes[0].childNodes[1].childNodes[0];
                        _this.multiSelectRef.hide = _this.onHide;
                    }
                }, key: def.id, id: def.id, disabled: def.disabled || def.readonly, onFocus: this.handleFocus, onBlur: this.handleBlur, options: supportedValues, onChange: this.onChange(def), value: this.value || '' || [], tooltip: hint, selectedItemTemplate: this.optionRender(supportedValues), selectedItemsLabel: 'Выбрано элементов: {0}', maxSelectedLabels: 5, 
                // @ts-expect-error
                resetFilterOnHide: true })),
            React.createElement(ControlError, { error: this.error, touched: this.touched })));
    };
    return MultiSelectControl;
}(FormBaseElement));
export { MultiSelectControl };
//# sourceMappingURL=MultiSelect.js.map